import React from 'react';

import PasswordTextfield from 'components/textfield/PasswordTextfield';

const PasswordInput = ({
  value,
  onChange,
  errorMessage,
  label = 'Password',
}) => {
  return (
    <PasswordTextfield
      onChange={onChange}
      value={value}
      errorMessage={errorMessage}
      label={label}
    ></PasswordTextfield>
  );
};

export default PasswordInput;
